import "./InsurancePayorAdd.scss"
import React, { useState } from 'react'
import Heading from '../../common/Heading/Heading'
import { App, Button, Card, Col, Divider, Form, Input, Row, Select, Space, Spin } from 'antd'
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { addInsurancePayors, getExpenseAccounts, getInsurancePayorsById, getMedicalCodeStandards, getReceivableAccounts, updateInsurancePayors } from '../../../network/insurancePayor';
import { MdDelete } from 'react-icons/md';
import { PlusOutlined } from '@ant-design/icons';
const InsurancePayorAdd = ({t,edit}) => {
    const { message } = App.useApp();
    const {id} = useParams();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const client = useQueryClient();
    const [loadingAdd, setLoadingAdd] = useState(false);
            const { mutate: onAddInsurancePayors } = useMutation({
              mutationKey: ['addInsurancePayors'],
              mutationFn: (body) =>
                edit ? updateInsurancePayors({ body ,id}) : addInsurancePayors(body),
              onSuccess: (data) => {
                setLoadingAdd(false);
                if (data?.message?.status === 500) {
                  message.error(data?.message?.message);
                  return false;
                }
                message.success(data?.message?.message);
                client.invalidateQueries({ queryKey: [queryKeys.getInsurancePayors] });
                form.resetFields();
                navigate('/insurance_payors');
              },
              onError: (error) => {
                setLoadingAdd(false);
                console.log('error:', error);
              },
            });
            const onFinish = (values) => {
                console.log('Success:', values);
              setLoadingAdd(true);
              onAddInsurancePayors({
                insurance_payor_data: JSON.stringify({
                  insurance_payor_name: values.insurance_payor_name,
                  insurance_claim_credit_days: values.insurance_claim_credit_days,
                  // disabled: values.disabled ? 1 : 0,
                  claims_receivable_accounts: values.claims_receivable_accounts,
                  rejected_claims_expense_accounts: values.rejected_claims_expense_accounts,
                }),
              });
            };
    // getMedicalCodeStandards;
        const { data: insurancePayors, isLoading: isLoadingInsurancePayors  } = useQuery({
          queryKey: [queryKeys.getInsurancePayorsById, id],
          queryFn: () => getInsurancePayorsById(id),
          keepPreviousData: true,
          enabled: edit,
        });
        const { data: medicalCodeStandards  } = useQuery({
          queryKey: [queryKeys.getMedicalCodeStandards],
          queryFn: () => getMedicalCodeStandards(),
          keepPreviousData: true,
        });
        const { data: receivableAccounts } = useQuery({
          queryKey: [queryKeys.getReceivableAccounts],
          queryFn: () => getReceivableAccounts(),
          keepPreviousData: true,
        });
        const { data: expenseAccounts } = useQuery({
          queryKey: [queryKeys.getExpenseAccounts],
          queryFn: () => getExpenseAccounts(),
          keepPreviousData: true,
        });
        if(isLoadingInsurancePayors){
          return (
            <div 
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '85vh'
              }}
            >
              <Spin size="large"/>
            </div>
          )
        }
  return (
    <div className="insurance-payor">
      <Heading
        title={t.insurancePayor}
        subTitle={t.addInsurancePayor}
        path="/insurance_payors"
      />
      <Card>
        <h4 className="title-card">{t.EnterInsurancePayorInformation}</h4>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
          initialValues={
            edit
              ? {
                  ...insurancePayors?.data,
                  claims_receivable_accounts: insurancePayors?.data?.claims_receivable_accounts || [{}],
                  rejected_claims_expense_accounts: insurancePayors?.data?.rejected_claims_expense_accounts || [{}],
              }
              : {
                  claims_receivable_accounts: [{}],
                  rejected_claims_expense_accounts: [{}],
                }
          }
        >
          <Divider orientation="left">{t.InsurancePayorInformation}</Divider>
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                // name="firstName"
                name="insurance_payor_name"
                label={t.InsurancePayorName}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.InsurancePayorName} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                // name="firstName"
                name="insurance_claim_credit_days"
                label={t.InsuranceClaimCreditDays}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input type="number" placeholder={t.InsuranceClaimCreditDays} />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="medical_code_standard"
                label={t.medicalCodeStandard}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder={t.medicalCodeStandard}
                  style={{ width: '100%' }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  // onChange={(value, option) => {
                  //   handleItemChange(value, option);
                  // }}
                  options={medicalCodeStandards?.message?.medical_code_standards?.map(
                    (item) => ({
                      value: item?.name,
                      label: item?.medical_code,
                    })
                  )}
                />
              </Form.Item>
            </Col> */}
            <Divider orientation="left">{t.Accounts}</Divider>
            <Col span={24} className="accounts-col-form">
              <Form.List
                name="claims_receivable_accounts"
                style={{ width: '100%' }}
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields?.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          //   marginBottom: 8,
                          //   justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                        }}
                        // align="baseline"
                      >
                        <Form.Item
                          // name={[name, 'receivable_account']}
                          name={[name, 'account']}
                          label={t.ClaimsReceivableAccount}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                        >
                          <Select
                            placeholder={t.ClaimsReceivableAccount}
                            style={{ width: '100%' }}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? '')
                                .toLocaleLowerCase()
                                .includes(input)
                            }
                            filterSort={(optionA, optionB) =>
                              (optionA?.label ?? '')
                                .toLowerCase()
                                .localeCompare(
                                  (optionB?.label ?? '').toLowerCase()
                                )
                            }
                            // onChange={(value, option) => {
                            //   console.log(value, option);
                            //   form.setFieldsValue({
                            //     claims_receivable_accounts: [
                            //       { company: option?.data?.company },
                            //     ],
                            //   });
                            // }}
                            options={receivableAccounts?.message?.receivable_accounts?.map(
                              (item) => ({
                                value: item?.name,
                                label: item?.item_code,
                                data: { ...item, key },
                              })
                            )}
                          />
                        </Form.Item>
                        {/* <Form.Item
                          name={[name, 'company']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.company}
                        >
                          <Input
                            placeholder={t.company}
                            style={{ width: '100%' }}
                            disabled
                          />
                        </Form.Item> */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '15px',
                            margin: '0 10px',
                          }}
                        >
                          {fields.length > 1 && (
                            <Button
                              type="text"
                              onClick={() => remove(name)}
                              danger
                              icon={<MdDelete color="red" />}
                            />
                          )}
                          <Button
                            type="text"
                            onClick={() => add()}
                            icon={<PlusOutlined color="#1890ff" />}
                          />
                        </div>
                      </Space>
                    ))}
                  </>
                )}
              </Form.List>
            </Col>
            <Col span={24} className="accounts-col-form">
              <Form.List
                name="rejected_claims_expense_accounts"
                style={{ width: '100%' }}
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields?.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          //   marginBottom: 8,
                          //   justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                        }}
                        // align="baseline"
                      >
                        <Form.Item
                          // name={[name, 'expense_account']}
                          name={[name, 'account']}
                          label={t.RejectedClaimsExpenseAccount}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                        >
                          <Select
                            placeholder={t.RejectedClaimsExpenseAccount}
                            style={{ width: '100%' }}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? '')
                                .toLocaleLowerCase()
                                .includes(input)
                            }
                            filterSort={(optionA, optionB) =>
                              (optionA?.label ?? '')
                                .toLowerCase()
                                .localeCompare(
                                  (optionB?.label ?? '').toLowerCase()
                                )
                            }
                            // onChange={(value, option) => {
                            //   console.log(value, option);
                            //   form.setFieldsValue({
                            //     rejected_claims_expense_accounts: [
                            //       { company: option?.data?.company },
                            //     ],
                            //   });
                            // }}
                            options={expenseAccounts?.message?.expense_accounts?.map(
                              (item) => ({
                                value: item?.name,
                                label: item?.name,
                                data: { ...item, key },
                              })
                            )}
                          />
                        </Form.Item>
                        {/* <Form.Item
                          name={[name, 'company']}
                          style={{ width: '100%', marginBottom: '0px' }}
                          {...restField}
                          label={t.company}
                        >
                          <Input
                            placeholder={t.company}
                            style={{ width: '100%' }}
                            disabled
                          />
                        </Form.Item> */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '15px',
                            margin: '0 10px',
                          }}
                        >
                          {fields.length > 1 && (
                            <Button
                              type="text"
                              onClick={() => remove(name)}
                              danger
                              icon={<MdDelete color="red" />}
                            />
                          )}
                          <Button
                            type="text"
                            onClick={() => add()}
                            icon={<PlusOutlined color="#1890ff" />}
                          />
                        </div>
                      </Space>
                    ))}
                  </>
                )}
              </Form.List>
            </Col>
          </Row>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => navigate(-1)}>
            {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
}

export default InsurancePayorAdd